import { delay, put, select, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import { API_URL } from "utils/constants";
import { getDefaultHeaders } from "utils/helpers";
import { request } from "utils/request";
import { adminTemplateForm } from "../types";
import { selectPendingForm } from "./selector";

function* getDocumentsList() {
    yield delay(300)
    try {
        const options = {
            method: "GET",
            headers: getDefaultHeaders(),
        }
        const response = yield request(`${API_URL}/documents`, options)
        yield put(actions.getDocumentSuccess(response.data))
    } catch (error) {
        yield put(actions.getDocumentFailure())
    }
}

function* createDocumentSaga() {
    yield delay(300)
    try {
        const form: adminTemplateForm = yield select(selectPendingForm)
        const options = {
            method: "POST",
            headers: getDefaultHeaders(),
            body: JSON.stringify(form),
        }
        const response = yield request(`${API_URL}/documents/create`, options)
        yield put(actions.createDocumentSuccess(response.data))
    } catch (error) {
        yield put(actions.createDocumentFailure())
    }
}

export function* documentSaga() {
    yield takeLatest(actions.getDocumentList.type, getDocumentsList)
    yield takeLatest(actions.createDocument.type, createDocumentSaga)
}
